import { PrincipalAppCredential } from 'features/Principal/types/candidatesListTypes';
import { degreeField, examTypesMissouri } from 'utils/enums';

export const getMissouriCredentialExamsText = (credential: PrincipalAppCredential) => {
  let credentialString = '';
  const credentialExams = credential.credential_exams_passed;

  const examTypesMissouriArray = examTypesMissouri();
  let examsMissouriString = `Exams Passed: ${credentialExams?.map((item) => {
    const string = examTypesMissouriArray.find((a) => a.value === item).label;
    return string;
  })}`;
  examsMissouriString = examsMissouriString.replace(/,/g, '; ');

  return (credentialString += examsMissouriString);
};

export const getDegreeText = (value: string) => {
  const newValue = parseInt(value, 10);
  const option = degreeField().find((o) => o.value === newValue);
  return option && option.label;
};
